import { RESOURCES_NAMES } from "@/const/resource.constants"
import { useHttp } from "@/hooks/useHttp"

import type { Config, Params } from "@/hooks/useHttp"
import type {
  FilterScanHistoryResponse,
  ScanHistoryResponse,
  ScanHistoryStatisticsResponse
} from "./useScanHistory.types"

const DEFAULT_CONFIG = {
  refetchInterval: 1000 * 60 * 5, // 5 minutes
  refetchIntervalInBackground: true
}

export const useGetScanHistory = <T = ScanHistoryResponse, S = T>(
  params?: Params,
  config?: Config<T, S>
) => {
  const { ROOT: SCAN_HISTORY } = RESOURCES_NAMES.SCAN_HISTORY
  const context = useHttp<T, S>(SCAN_HISTORY, params, {
    ...config,
    ...DEFAULT_CONFIG
  })

  return context
}

export const useGetFiltersScanHistory = <
  T extends FilterScanHistoryResponse,
  S = T
>(
  params?: Params,
  config?: Config<T, S>
) => {
  const { FILTERS: SCAN_HISTORY_FILTERS } = RESOURCES_NAMES.SCAN_HISTORY
  const context = useHttp<T, S>(SCAN_HISTORY_FILTERS, params, config)

  return context
}

export const useGetScanHistoryStatistics = <
  T extends ScanHistoryStatisticsResponse,
  S = T
>(
  params?: Params,
  config?: Config<T, S>
) => {
  const { STATISTICS: SCAN_HISTORY_STATISTICS } = RESOURCES_NAMES.SCAN_HISTORY
  const context = useHttp<T, S>(SCAN_HISTORY_STATISTICS, params, {
    ...config,
    ...DEFAULT_CONFIG
  })

  return context
}
